import React from "react";
import PropTypes from "prop-types";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import { shortDateAndTimestamp } from "LIB/formatters/date";
import {
  DataTable,
  ExternalLink,
  SearchPropTypes
} from "MODULES/shared/components";
import { properCase } from "LIB/formatters/text";

function linkUrl(record) {
  if (record.status === "completed") {
    return (
      <ExternalLink url={record.public_download_url}>
        <span>{record.name}</span>
      </ExternalLink>
    );
  }
  return <span>{record.name}</span>;
}

function renderRow(r) {
  return (
    <tr key={r.id}>
      <td>{linkUrl(r)}</td>
      <td>{properCase(r.status)}</td>
      <td>{shortDateAndTimestamp(r.created_at)}</td>
    </tr>
  );
}

export function Table({ isLoading, results }) {
  return (
    <DataTable loading={isLoading}>
      <DataTable.Head>
        <th>Name</th>
        <th>Status</th>
        <th>Created At</th>
      </DataTable.Head>
      <DataTable.Body>{results.map(renderRow)}</DataTable.Body>
    </DataTable>
  );
}

Table.propTypes = {
  pushHistory: PropTypes.func.isRequired,
  ...SearchPropTypes
};

export default connect(undefined, { pushHistory: push })(Table);



// WEBPACK FOOTER //
// ./app/modules/Admin/Reports/Table.jsx